import React, { memo, FC } from "react";
import { gql } from "@apollo/client";

import PremiumFeature from "./PremiumFeature";

interface Props {
  className?: string;
  premiumLineItems: any[];
  coinsPerRecipient: number;
  openCoinInfoModalCallback?: any;
}

const NOOP = () => {};

const PremiumFeatureList: FC<Props> = ({
  className,
  premiumLineItems,
  coinsPerRecipient,
  openCoinInfoModalCallback,
}) => {
  const totalCoinString = `${coinsPerRecipient} ${
    coinsPerRecipient > 1 ? "Coins" : "Coin"
  }`;

  return (
    <div className={`mt-6 mb-6 paragraph-medium ${className}`}>
      {premiumLineItems.map((feature: any) => {
        const { item: { type, kind } } = feature;
        return (
          <PremiumFeature
            key={`${type}-${kind}`}
            className="mb-4"
            feature={feature}
          />
        );
      })}
      <hr className="my-6 border-t border-dove" />
      <div className="flex text-lapel justify-between my-2 paragraph-medium font-medium text-lapel">
        <span>Total per invite</span>
        <span>{totalCoinString}</span>
      </div>
      <span
        className="text-gatsby cursor-pointer"
        onClick={openCoinInfoModalCallback || NOOP}
      >
        Calculate total cost
      </span>
    </div>
  );
};

export const PremiumFeatureListFragments = gql`
  fragment PremiumFeatureListFragment on FlyerCompositionDetail {
    premiumLineItems {
      item {
        type
        kind
        cost
        resources {
          asset {
            renditions
          }
        }
      }
    }
  }
`;

export default memo(PremiumFeatureList);